import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=d0b01a86&"
import script from "./columns.vue?vue&type=script&lang=js&"
export * from "./columns.vue?vue&type=script&lang=js&"
import style0 from "./columns.vue?vue&type=style&index=0&id=d0b01a86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports